import { useGetSalesTargetReportQuery } from "@states/report/report.api";
import { TSuccessResponse } from "../../types/general/TSuccessResponse";

const useGetSalesTargetReport = (args: {
  assignee_id?: number;
  product_target_ids?: (string | number | Date)[]
}) => {
  const {
    data: rawData,
    error,
    isLoading,
    refetch,
    isFetching,
  } = useGetSalesTargetReportQuery({ ...args });

  const salesTargetResponse = rawData as any as TSuccessResponse<any>;

  return {
    salesTargetData: salesTargetResponse?.data,
    salesTargetTotals: (salesTargetResponse as any)?.totals,
    salesTargetMessage: salesTargetResponse?.message,
    salesTargetSuccess: salesTargetResponse?.success,
    salesTargetError: error,
    salesTargetLoading: isLoading,
    salesTargetRefetch: refetch,
    salesTargetFetching: isFetching,
  };
};

export default useGetSalesTargetReport;
